import { getcause } from "@/server/api";
import { loadFuture, loadOverdue } from "@/server/loan";
import { debtorExpire } from "@/server/debtor";
const state = {
  data: {},
  list: [],
};
const mutations = {
  SET_DATA: (state, data) => {
    state.data = data;
  },
  SET_LIST: (state, data) => {
    state.list = data;
  },
};
const actions = {
  async getlist({ commit, state, dispatch }, data) {
    await dispatch("potData", data);
    return await new Promise((resolve, reject) => {
      getcause(state.data).then((e) => {
        //获取案件详情信息，并返回
        dispatch("setList", e.list);
        resolve(e.list);
      });
    });
  },
  putInData({ commit, state, dispatch }, { index, key, value } = data) {
    let list = JSON.parse(JSON.stringify(state.list));
    list[index][key] = value;
    dispatch("setList", list);
  },
  potData({ commit }, data) {
    commit("SET_DATA", data);
  },
  setList({ commit }, data) {
    commit("SET_LIST", data);
  },
  getloadFuture({ commit }, data) {
    //即将还款
    return new Promise((resolve, reject) => {
      loadFuture(data).then((e) => {
        resolve(e);
      });
    });
  },
  getloadOverdue({ commit }, data) {
    //逾期列表
    return new Promise((resolve, reject) => {
      loadOverdue(data).then((e) => {
        resolve(e);
      });
    });
  },
  getdebtorExpire({ commit }, data) {
    //保全列表
    return new Promise((resolve, reject) => {
      debtorExpire(data).then((e) => {
        resolve(e);
      });
    });
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
